import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import topic from 'dojo/topic';
import { compose, mdsWidget } from 'dojo/_base/declare';
import Messages_PullRequestData from '../../Operations/MessageCenter/Messages_PullRequestData';
import Message from '../../Operations/MessageCenter/Message';
import template from './MessageListener.html?raw';
//import Edit = require("../../UI/Edit/Edit");
//import "../../UI/Edit/Edit";
//import Button = require("../../UI/Button/Button");
//import "../../UI/Button/Button";
//import GenericDialog = require("../../UI/GenericDialog/GenericDialog");
//import "../../UI/GenericDialog/GenericDialog";
//import DataItems = require("DataItems");


class MessageListener extends compose(_WidgetBaseSP) {
   templateString: any = template;

    protected _requestData: Messages_PullRequestData = { lastTimeStamp: null, timeStamp: null, includeConfirmationNeededOnly: false, includeProcessed: true }; // datum der letzten Abfrage - Messages bis dahin haben wir schon geholt

    protected _intervalHandle: number = null;
    protected _intervalMS: number = -1;

    receivedMessages: Array<Message>;

    unreadMessageCount: number = 0;

    // diverse Nodes:
    

    sendRequest(): void {

        this.StandbyStart();
        
        //this._requestData.timeStamp = new Date; // Zeitstempel auf JETZT stellen

        console.log("MessageListener - Request", this._requestData);

        this.RequestManager.post(window.appRoot + "Operation_MessageAck/PullMessages",
            {
                "jsonData": JSON.stringify(this._requestData)
            },
            lang.hitch(this, this._onSendRequestResponse),
            lang.hitch(this, this._onSendRequestError),
            false            
        );
    }

    protected _onSendRequestResponse(response: any): void {
        this.StandbyStop();
        console.log("MessageListener _onSendRequestResponse", response);

        let newMessages: Array<Message> = [];
        let updatedMessages: Array<Message> = [];

        let results: Array<Message> = response.filteredResults;
        let allMessages: Array<string> = response._all;

        //this.emit("messagesLoaded"); // usw ... evtl noch wie viele neu sind und obs überhaupt welche gibt

        for (var i = 0; i < results.length; i++) {
            var message: Message = results[i];
            var messageId: string = message.ID;

            // prüfen obs die Message schon gibt oder obs ein Update dafür gibt?
            var existingMessage: number = this.getMessageIndexById(messageId);
            if (existingMessage != -1) {
                if (this.receivedMessages[existingMessage].is_marked_as_read != true) {
                    this.unreadMessageCount--;
                }
                if (message.is_marked_as_read != true) {
                    this.unreadMessageCount++;
                }
                this.receivedMessages.splice(existingMessage, 1, message); // bestehende Message raus, neue Message an dieselbe Stelle

                updatedMessages.push(message);
            } else {
                if (message.is_marked_as_read != true) {
                    this.unreadMessageCount++;
                }
                this.receivedMessages.push(message);
                newMessages.push(message);
            }            
        }

        topic.publish("Messages/Loaded", newMessages, updatedMessages, this.receivedMessages, this.unreadMessageCount);

        this._requestData.lastTimeStamp = new Date;

        this.showErrorMessage("");
    }

    protected _onSendRequestError(error: more.requestErrorMessage): void {
        this.StandbyStop();
        this.showErrorMessage(error.Message);
        console.error("_onSendRequestError", error.url, error.Message);
    }

    getMessageById(messageID: string): Message {
        var index: number = this.getMessageIndexById(messageID);

        if (index != -1) {
            return this.receivedMessages[index];
        }

        return null;
    }

    protected getMessageIndexById(messageID: string): number {
        for (var i = 0; i < this.receivedMessages.length; i++) {
            if (this.receivedMessages[i].ID == messageID) {
                return i;
            }
        }

        return -1;
    }

    showErrorMessage(message?: string) {
        if (message == null || typeof (message) == "undefined" || message == "") {
            
        } else {
            alert(message);
        }
    }

    protected _onCheckSession(data?: any): void {
        //console.debug("MessageListener - _onCheckSession", data);

        if (typeof (data) == "object") {
            if (data.result == null) {
                this._onCloseSession();
            } else if (typeof (data.result) == "object") {
                this._onOpenSession();
            }
        }
    }

    protected _onOpenSession(): void {

        //console.debug("MessageListener - onOpenSession");

        if (this._intervalHandle == null) { // noch bissl unsauber: wir kommen hier recht oft her, daher so abfangen damit das nicht zigmal passiert
            this.sendRequest();
        }

        if (this._intervalMS != null && this._intervalMS > 0 && this._intervalHandle == null) {
            console.debug("Message Listener - start Interval");
            this._intervalHandle = setInterval(lang.hitch(this, this.sendRequest), this._intervalMS);
        }
    }

    protected _onCloseSession(): void {

        console.debug("MessageListener - onCloseSession");

        if (this._intervalHandle != null) {
            console.debug("Message Listener - STOP Interval");
            clearInterval(this._intervalHandle);
            this._intervalHandle = null;
        }
    }


   
    setConfig(config: Messages_PullRequestData): void {
        if (typeof (config) != "undefined" && config != null) {
            this._requestData = config;
        }
    }



    checkForExistingSession(): void {


        
    }

    // Dojo-Setter und Getter
    _setIntervalAttr(pullingIntervalMS?: number): void {
        this._intervalMS = pullingIntervalMS;
    }

    _setIncludeProcessedAttr(bSet: boolean): void {
        this._requestData.includeProcessed = bSet === true;
    }

    _setIncludeConfirmationNeededOnlyAttr(bSet: boolean): void {
        this._requestData.includeConfirmationNeededOnly = bSet === true;
    }

    //_setInitialConfigAttr(initialConfig?: Messages_PullRequestData): void {
    //    if (typeof (initialConfig) != "undefined" && initialConfig != null) {
    //        this._requestData = initialConfig;
    //    }

    //}

    protected _setupSubscriptions(): void {
        //this._topics.push(topic.subscribe("/Session/Open", lang.hitch(this, this._onOpenSession))); // 
        this._topics.push(topic.subscribe("/Session/CheckForExistingSession", lang.hitch(this, this._onCheckSession)));
        this._topics.push(topic.subscribe("/Session/Close", lang.hitch(this, this._onCloseSession)));
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.receivedMessages = new Array<Message>();

        this._setupSubscriptions();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        //console.log("MessageListener - startup");
        //window.moreCore.Operations.MessageListener = this;

        if (typeof (window.moreCore) == "undefined") {
            window.moreCore = {};
        }
    //    if (typeof (window.moreCore.Operations) == "undefined") {
    //        window.moreCore.Operations = { messageListener: null };
    //    }

    //    if (window.moreCore.Operations.messageListener == null) {
    //        window.moreCore.Operations.messageListener = this;
    //    } else {
    //        this.destroy();
    //    }
    }

    destroy(args?: any): void {

        if (this._intervalHandle != null) {
            clearInterval(this._intervalHandle);
            this._intervalHandle = null;
        }

        //if (window.moreCore.Operations.messageListener != null) {
        //    window.moreCore.Operations.messageListener = null;
        //}

        super.destroy.apply(this, arguments as any);
    }

}

export default mdsWidget(MessageListener);